export const SEARCH_TEMPLATE_CS_ENTRY_ID = 'BASE_RULE';
export const DEFAULT_USER_STATE = 'WA';
export const CLP_AD_PLACEMENT_FALLBACK_DEVELOPER_KEY = 'clp-ad-placements';
